<script setup lang="ts">
import CvrUpload from "@/types/CvrUpload";
import ConfirmationModal from "@/components/CvrConvert/ConfirmationModal.vue";
import { ref } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

const props = defineProps<{
  item: CvrUpload,
  reload: () => void
  showFlash: (message: string, type: string) => void
}>();

const requesting = ref(false);
const confirmationModalState = ref(false);

async function abort() {
  requesting.value = true;
  const parentId = props.item.parent_id;
  if (parentId) {
    const res = await Api().abortCvrUpload(parentId).catch((error) => {
      console.error(error);
    });
    if (res) {
      props.showFlash(
        i18n.global.t('pages.cvr_uploads.abortMessages.success'), "success");
      props.reload();
    }
  } else {
    console.error("parent_id is null and cannot be used to abort cvr upload request.");
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.abortMessages.error'), "error");
  }
  confirmationModalState.value = false;
  requesting.value = false;
}

function showConfirmation() {
  confirmationModalState.value = true;
}

function closeConfirmation() {
  confirmationModalState.value = false;
}
</script>

<template>
  <v-btn
    @click="showConfirmation"
    class="bg-warning"
  >
    {{ i18n.global.t('pages.cvr_uploads.list.abortBtn') }}
  </v-btn>
  <ConfirmationModal
    :modalState="confirmationModalState"
    @confirm="abort"
    @cancel="closeConfirmation"
    :loading="requesting"
    :title="i18n.global.t('pages.cvr_uploads.abortMessages.confirmationModalTitle')"
    :note="i18n.global.t('pages.cvr_uploads.abortMessages.confirmationModalContent')"
    :rightBtnName="i18n.global.t('pages.cvr_uploads.abortMessages.confirmationModalBtnLabel')"
  />
</template>

<style scoped>
</style>
